import { h, Host } from "@stencil/core";
/**
 * The `ch-grid-rowset-legend` component represents a caption for the `ch-grid-rowset` element.
 */
export class ChGridRowsetLegend {
    /**
     * Event emitted when the legend is clicked.
     */
    rowsetLegendClicked;
    clickHandler() {
        this.rowsetLegendClicked.emit();
    }
    render() {
        return (h(Host, null, h("div", { part: "caret" }), h("label", { part: "selector-label" }, h("input", { type: "checkbox", part: "selector" })), h("div", { part: "icon" }), h("slot", null)));
    }
    static get is() { return "ch-grid-rowset-legend"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-rowset-legend.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-rowset-legend.css"]
        };
    }
    static get events() {
        return [{
                "method": "rowsetLegendClicked",
                "name": "rowsetLegendClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the legend is clicked."
                },
                "complexType": {
                    "original": "CustomEvent",
                    "resolved": "CustomEvent<any>",
                    "references": {
                        "CustomEvent": {
                            "location": "global",
                            "id": "global::CustomEvent"
                        }
                    }
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "click",
                "method": "clickHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }];
    }
}
//# sourceMappingURL=ch-grid-rowset-legend.js.map
